import { authOrganizationInitialState } from './authOrganization.initialState';
import { STARTER_PACKAGE, STANDARD_PACKAGE } from './../../utils/authOrg.constants';
import { path, pathOr } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingAuthOrganizationUpdate = state =>
	path(['authOrganization', 'pendingUpdate'], state);
export const getPendingAuthOrganizationCreate = state =>
	path(['authOrganization', 'pendingCreate'], state);
export const getPendingAuthOrganizations = state => ({
	update: getPendingAuthOrganizationUpdate(state),
	create: getPendingAuthOrganizationCreate(state),
});

export const getAuthOrganizationErrorUpdate = state =>
	path(['authOrganization', 'updateError'], state);
export const getAuthOrganizationErrorCreate = state =>
	path(['authOrganization', 'createError'], state);
export const getAuthOrganizationErrors = state => ({
	update: getAuthOrganizationErrorUpdate(state),
	create: getAuthOrganizationErrorCreate(state),
});

export const getAuthOrganizationById = (state, id) =>
	pathOr({}, ['authOrganization', 'entities'], state)[id] || authOrganizationInitialState;
export const getEntities = state => path(['authOrganization', 'entities'], state);
export const getAuthOrganizations = createSelector(getEntities, entities =>
	Object.values(entities),
);
export const getFirstAuthOrganizationName = createSelector(getAuthOrganizations, organizations =>
	path(['0', 'name'], organizations),
);

export const isStandardPackage = createSelector(
	getAuthOrganizations,
	organizations =>
		organizations.length > 0 &&
		(!organizations[0].feature_package ||
			organizations[0].feature_package === STANDARD_PACKAGE),
);

export const isStarterPackage = createSelector(
	getAuthOrganizations,
	organizations =>
		organizations.length > 0 &&
		(!organizations[0].feature_package || organizations[0].feature_package === STARTER_PACKAGE),
);



// WEBPACK FOOTER //
// ./src/redux/authOrganizations/authOrganization.selector.js